import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    margin: '10px 40px 24px',
    flexWrap: 'wrap',
    flexDirection: 'column'
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px',
  },
  subTitle: {
    color: '#545455',
    fontSize: '16px',
    marginTop: '10px',
  }
}))

export { useStyles }
